export default __webpack_public_path__ + "static/rec-2011-i-40c57e79e796ef718e0e68012d156498.png";